// Text fields only: toggles and checkboxes often come first in a form, and rsuite pickers render
// read-only inputs that do not accept typing.
const EDITABLE_FIELD_SELECTOR = [
  'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([disabled]):not([readonly]):not([tabindex="-1"])',
  'textarea:not([disabled]):not([readonly])',
  '[contenteditable="true"]',
].join(', ')

/**
 * Focuses the first editable field inside `container` without scrolling to it. Selects a prefilled
 * text, such as the placeholder label of a new navigation node, so typing replaces it.
 */
export function focusFirstField(container: HTMLElement) {
  const field = container.querySelector<HTMLElement>(EDITABLE_FIELD_SELECTOR)
  field?.focus({preventScroll: true})
  if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) field.select()
}

/**
 * Scrolls a newly added list item into view and focuses its first editable field, so editors can
 * type right away. Waits one frame because rich text fields mount their editable area after the
 * item itself renders. Mirrors `revealListItem` in @dudagroup/editor, which the generic list
 * fields use.
 */
export function revealListItem(item: HTMLElement) {
  requestAnimationFrame(() => {
    item.scrollIntoView({behavior: 'smooth', block: 'center'})
    focusFirstField(item)
  })
}
